<template>
  <div class="progress">
    <div class="progress__bar" :style="{ width: progressBarWidth }"></div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    progressBarWidth: {
      type: String,
      required: true,
      default: '0%',
    },
  },
};
</script>

<style lang="scss" scoped>
.progress__bar {
  border-radius: 3.5px;
  width: 0%;
  height: 100%;
  max-width: 100%;
  float: left;
  background-color: #f083a6;
  transition: width 0.6s ease;
}
</style>
